/* eslint-disable react/jsx-no-target-blank */
// import React from 'react'
import { useIntl } from 'react-intl'
// import {KTSVG} from '../../../../helpers'
// import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { usePermission } from '../../../../../app/modules/auth/core/usePermission'
const SidebarMenuMain = () => {
  const intl = useIntl()
  const { hasPermission, isSuperAdmin } = usePermission()
  const canDailyReport =
    hasPermission('reports.read') && hasPermission('reports.revenue.read')

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
      {hasPermission('operationalZones.read') && (
        <SidebarMenuItem
          to='/operational-zones-city'
          icon='/media/icons/duotune/maps/map002.svg'
          title='Operational Zones'
          fontIcon='bi-layers'
        />
      )}

      {hasPermission('bookings.read') && hasPermission('operationalZones.read') && (
        <SidebarMenuItem
          to='/dispatch-map'
          icon='/media/icons/duotune/maps/map003.svg'
          title='Dispatch Map'
          fontIcon='bi-geo-alt'
        />
      )}

      {hasPermission('bookings.read') && (
        <SidebarMenuItem
          to='/staff-calendar'
          icon='/media/icons/duotune/general/gen014.svg'
          title='Staff Calendar'
          fontIcon='bi-calendar-week'
        />
      )}
      {hasPermission('catalog.read') && (
        <SidebarMenuItem
          to='/services'
          icon='/media/icons/duotune/general/gen054.svg'
          title='Service'
          fontIcon='bi-layers'
        />
      )}

      {hasPermission('catalog.read') && (
        <SidebarMenuItem
          to='/product-group'
          icon='/media/icons/duotune/general/gen056.svg'
          title='Service Group'
          fontIcon='bi-layers'
        />
      )}
      {hasPermission('catalog.read') && (
        <SidebarMenuItem
          to='/products'
          icon='/media/icons/duotune/general/gen028.svg'
          title='Packages'
          fontIcon='bi-layers'
        />
      )}

      {(hasPermission('adminUsers.read') ||
        hasPermission('users.read') ||
        hasPermission('providers.read')) && (
        <SidebarMenuItemWithSub
          to='/manage-user/company-employee'
          title='Manage Users'
          icon='/media/icons/duotune/communication/com006.svg'
          fontIcon='bi-person'
        >
          {hasPermission('adminUsers.read') && (
            <SidebarMenuItem
              to='/manage-user/company-employee'
              title='Call Genie Staff'
              hasBullet={true}
            />
          )}
          {hasPermission('users.read') && (
            <SidebarMenuItem
              to='/manage-user/consumer'
              title='Consumer'
              hasBullet={true}
            />
          )}
          {hasPermission('providers.read') && (
            <SidebarMenuItem
              to='/manage-user/provider'
              title='Provider'
              hasBullet={true}
            />
          )}
          {isSuperAdmin && (
            <SidebarMenuItem to='/roles' title='Roles & Privileges' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}

      {hasPermission('bookings.read') && (
        <SidebarMenuItem
          to='/booking'
          icon='/media/icons/duotune/ecommerce/ecm009.svg'
          title='Bookings'
          fontIcon='bi-layers'
        />
      )}

      {/* Genie AI, the ask-your-data assistant. Super admin only; the route and the server enforce it too,
          so hiding the item is a courtesy, not the control. */}
      {isSuperAdmin && (
        <SidebarMenuItem
          to='/genie-ai'
          icon='/media/icons/duotune/general/genie-ai.svg'
          title='Genie AI'
          fontIcon='bi-stars'
          badge='Beta'
        />
      )}

      {/* Reports & Analytics. Each tab is its own route so it can be bookmarked
          and linked to; the shared filters live above them. */}
      {hasPermission('reports.read') && (
        <SidebarMenuItemWithSub
          to='/reports'
          title='Reports & Analytics'
          icon='/media/icons/duotune/graphs/gra007.svg'
          fontIcon='bi-graph-up'
        >
          <SidebarMenuItem
            to='/reports/cancellations'
            title='Cancellation Reasons'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/reports/overview'
            title='Overview'
            hasBullet={true}
          />
          <SidebarMenuItem to='/reports/revenue' title='Revenue' hasBullet={true} />
          <SidebarMenuItem
            to='/reports/customers'
            title='Customers'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/reports/referrals'
            title='Referrals'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/reports/geography'
            title='Geography'
            hasBullet={true}
          />
          <SidebarMenuItem to='/reports/exports' title='Exports' hasBullet={true} />
          <SidebarMenuItem
            to='/cancellation-reasons'
            title='Cancellation Reasons'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}
      {/* Support. Each child carries its own permission; the parent shows if any child does. */}
      {(canDailyReport || hasPermission('supportPlaybook.read')) && (
        <SidebarMenuItemWithSub
          to={canDailyReport ? '/daily-support-report' : '/support-playbook'}
          title='Support'
          icon='/media/icons/duotune/communication/com012.svg'
          fontIcon='bi-headset'
        >
          {canDailyReport && (
            <SidebarMenuItem
              to='/daily-support-report'
              title='Daily Support Report'
              hasBullet={true}
            />
          )}
          {hasPermission('supportPlaybook.read') && (
            <SidebarMenuItem
              to='/support-playbook'
              title='Support Playbook'
              hasBullet={true}
            />
          )}
        </SidebarMenuItemWithSub>
      )}
      {hasPermission('wallet.read') && (
        <SidebarMenuItem
          to="/wallet-management"
          icon="/media/icons/duotune/finance/fin002.svg"
          title="Wallet Management"
          fontIcon="bi-credit-card"
        />
      )}
      {hasPermission('wallet.read') && (
        <SidebarMenuItem
          to="/wallet-withdraw"
          icon="/media/icons/duotune/finance/fin003.svg"
          title="Wallet Withdraw"
          fontIcon="bi-layers"
        />
      )}
      {hasPermission('offers.read') && (
        <SidebarMenuItem
          to='/offers'
          icon='/media/icons/duotune/ecommerce/ecm008.svg'
          title='Offers'
          fontIcon='bi-gift'
        />
      )}
      {hasPermission('discounts.read') && (
        <SidebarMenuItemWithSub
          to='/discounts'
          title='Discounts'
          icon='/media/icons/duotune/ecommerce/ecm011.svg'
          fontIcon='bi-percent'
        >
          {/* <SidebarMenuItem
                to='/discounts/promo'
                title='Promo Discounts'
                hasBullet={true}
            /> */}
          <SidebarMenuItem
            to='/discounts/rules'
            title='Discount Rules'
            hasBullet={true}
          />
          {/* <SidebarMenuItem
                to='/discounts/provider-agreements'
                title='Provider Agreements'
                hasBullet={true}
            />
            <SidebarMenuItem
                to='/discounts/campaigns'
                title='Campaigns'
                hasBullet={true}
            /> */}
          <SidebarMenuItem
            to='/discounts/redemptions'
            title='Redemptions'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}
      {hasPermission('banners.read') && (
        <SidebarMenuItem
          to='/banner-management'
          icon='/media/icons/duotune/general/gen006.svg'
          title='Banners Management'
          fontIcon='bi-layers'
        />
      )}
      {/* <SidebarMenuItem
        to='/transaction'
        icon='/media/icons/duotune/finance/fin003.svg'
        title='Transactions'
        fontIcon='bi-layers'
      />
      <SidebarMenuItem
        to='/commission'
        icon='/media/icons/duotune/finance/fin003.svg'
        title='Commission History'
        fontIcon='bi-layers'
      /> */}
      {hasPermission('payments.read') && (
        <SidebarMenuItem
          to='/account'
          icon='/media/icons/duotune/finance/fin008.svg'
          title='Accounts'
          fontIcon='bi-layers'
        />
      )}

      {hasPermission('transactions.read') && (
        <SidebarMenuItem
          to='/payment-transaction'
          icon='/media/icons/duotune/finance/fin003.svg'
          title='Payment Transactions'
          fontIcon='bi-layers'
        />
      )}
      {hasPermission('tips.read') && (
        <SidebarMenuItem
          to='/tips'
          icon='/media/icons/duotune/finance/fin010.svg'
          title='Tips'
          fontIcon='bi-heart'
        />
      )}
      {hasPermission('ratings.read') && (
        <SidebarMenuItem
          to='/ratings'
          icon='/media/icons/duotune/general/gen029.svg'
          title='Provider Ratings'
          fontIcon='bi-layers'
        />
      )}

      {hasPermission('users.read') && (
        <SidebarMenuItem
          to='/customers-cart'
          icon='/media/icons/duotune/ecommerce/ecm009.svg'
          title='Customers Cart'
          fontIcon='bi-layers'
        />
      )}

      {hasPermission('questionnaire.read') && (
        <SidebarMenuItem
          to='/questionare'
          icon='/media/icons/duotune/general/gen019.svg'
          title='Questionare'
          fontIcon='bi-layers'
        />
      )}
      {hasPermission('campaigns.read') && (
        <SidebarMenuItem
          to='/campaign-tracking'
          icon='/media/icons/duotune/general/gen051.svg'
          title='Campaign Tracking'
          fontIcon='bi-layers'
        />
      )}

      {hasPermission('blogs.read') && (
        <SidebarMenuItem
          to='/blogs'
          icon='/media/icons/duotune/general/gen054.svg'
          title='Blogs'
          fontIcon='bi-layers'
        />
      )}

      {hasPermission('announcements.read') && (
        <SidebarMenuItem
          to='/announcement'
          icon='/media/icons/duotune/communication/com004.svg'
          title='Annoucement'
          fontIcon='bi-layers'
        />
      )}

      {hasPermission('notificationRules.read') && (
        <SidebarMenuItem
          to='/notification-rules'
          icon='/media/icons/duotune/communication/com004.svg'
          title='Notification Rules'
          fontIcon='bi-bell'
        />
      )}

      {/* 
      <div className="menu-item">
        <div className="menu-content pt-8 pb-2">
          <span className="menu-section text-muted text-uppercase fs-8 ls-1">
            Crafted
          </span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to="/crafted/pages"
        title="Pages"
        fontIcon="bi-archive"
        icon="/media/icons/duotune/general/gen022.svg"
      >
        <SidebarMenuItemWithSub
          to="/crafted/pages/profile"
          title="Profile"
          hasBullet={true}
        >
          <SidebarMenuItem
            to="/crafted/pages/profile/overview"
            title="Overview"
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/crafted/pages/profile/projects"
            title="Projects"
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/crafted/pages/profile/campaigns"
            title="Campaigns"
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/crafted/pages/profile/documents"
            title="Documents"
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/crafted/pages/profile/connections"
            title="Connections"
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub
          to="/crafted/pages/wizards"
          title="Wizards"
          hasBullet={true}
        >
          <SidebarMenuItem
            to="/crafted/pages/wizards/horizontal"
            title="Horizontal"
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/crafted/pages/wizards/vertical"
            title="Vertical"
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to="/crafted/accounts"
        title="Accounts"
        icon="/media/icons/duotune/communication/com006.svg"
        fontIcon="bi-person"
      >
        <SidebarMenuItem
          to="/crafted/account/overview"
          title="Overview"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/account/settings"
          title="Settings"
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to="/error"
        title="Errors"
        fontIcon="bi-sticky"
        icon="/media/icons/duotune/general/gen040.svg"
      >
        <SidebarMenuItem to="/error/404" title="Error 404" hasBullet={true} />
        <SidebarMenuItem to="/error/500" title="Error 500" hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to="/crafted/widgets"
        title="Widgets"
        icon="/media/icons/duotune/general/gen025.svg"
        fontIcon="bi-layers"
      >
        <SidebarMenuItem
          to="/crafted/widgets/lists"
          title="Lists"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/widgets/statistics"
          title="Statistics"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/widgets/charts"
          title="Charts"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/widgets/mixed"
          title="Mixed"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/widgets/tables"
          title="Tables"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/widgets/feeds"
          title="Feeds"
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <div className="menu-item">
        <div className="menu-content pt-8 pb-2">
          <span className="menu-section text-muted text-uppercase fs-8 ls-1">
            Apps
          </span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to="/apps/chat"
        title="Chat"
        fontIcon="bi-chat-left"
        icon="/media/icons/duotune/communication/com012.svg"
      >
        <SidebarMenuItem
          to="/apps/chat/private-chat"
          title="Private Chat"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/apps/chat/group-chat"
          title="Group Chart"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/apps/chat/drawer-chat"
          title="Drawer Chart"
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to="/apps/user-management/users"
        icon="/media/icons/duotune/general/gen051.svg"
        title="User management"
        fontIcon="bi-layers"
      />
      <div className="menu-item">
        <a
          target="_blank"
          className="menu-link"
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + "/docs/changelog"}
        >
          <span className="menu-icon">
            <KTSVG
              path="/media/icons/duotune/general/gen005.svg"
              className="svg-icon-2"
            />
          </span>
          <span className="menu-title">
            Changelog {process.env.REACT_APP_VERSION}
          </span>
        </a>
      </div> */}
    </>
  )
}

export { SidebarMenuMain }
